import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class TabStore {
  patientDetailsCurrentTabIndex: number = 0;

  constructor() {
    makeObservable(this, {
      patientDetailsCurrentTabIndex: observable,
      setPatientDetailsCurrentTabIndex: action,
      removePatientDetailsCurrentTabIndex: action,
      clearTabStore: action,
    });
    makePersistable(this, {
      name: 'TabStore',
      properties: ['patientDetailsCurrentTabIndex'],
      storage: window.localStorage,
    });
  }

  setPatientDetailsCurrentTabIndex(currentTabIndex: number) {
    this.patientDetailsCurrentTabIndex = currentTabIndex;
  }

  removePatientDetailsCurrentTabIndex() {
    this.patientDetailsCurrentTabIndex = 0;
  }

  clearTabStore() {
    this.patientDetailsCurrentTabIndex = 0;
  }
}
export default TabStore;
